function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base';
import './style.less';

var Switcher = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Switcher, _KZUIComponent);

  var _super = _createSuper(Switcher);

  function Switcher(props) {
    var _this;

    _classCallCheck(this, Switcher);

    _this = _super.call(this, props);

    _this.autoBind('handleChange');

    return _this;
  }

  _createClass(Switcher, [{
    key: "handleChange",
    value: function handleChange(index) {
      if (this.props.onChange) {
        this.props.onChange(index);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var clsPrefix = 'kui-switcher';
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          itemStyle = _this$props.itemStyle,
          itemClassName = _this$props.itemClassName,
          titles = _this$props.titles,
          curIndex = _this$props.curIndex;
      var cls = classNames(clsPrefix, className);
      return /*#__PURE__*/React.createElement("div", {
        className: cls,
        style: style
      }, titles.map(function (title, index) {
        return /*#__PURE__*/React.createElement("div", {
          role: "presentation",
          key: index,
          style: itemStyle,
          onClick: function onClick() {
            return _this2.handleChange(index);
          },
          className: index === curIndex ? "".concat(clsPrefix, "-item ").concat(clsPrefix, "-cur ").concat(itemClassName) : "".concat(clsPrefix, "-item ").concat(itemClassName)
        }, title);
      }));
    }
  }]);

  return Switcher;
}(KZUIComponent);

Switcher.defaultProps = {
  titles: [],
  curIndex: 0,
  onChange: null,
  Style: {},
  ClassName: '',
  itemStyle: {},
  itemClassName: ''
};
Switcher.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.string),
  curIndex: PropTypes.number,
  onChange: PropTypes.func,
  Style: PropTypes.objectOf(PropTypes.any),
  ClassName: PropTypes.string,
  itemStyle: PropTypes.objectOf(PropTypes.any),
  itemClassName: PropTypes.string
};
export default Switcher;